import { Money } from '@ap/interface-bspc-core';
import { EnergyLabel, Property, PropertyType } from '@ap/ap-interface-apix-hypotheken-berekening';

export function getPropertyType(propertyTypeString: string): PropertyType {
    switch (propertyTypeString) {
        case PropertyType.NONE:
            return PropertyType.NONE;
        case PropertyType.EXISTING_BUILD:
            return PropertyType.EXISTING_BUILD;
        case PropertyType.NEW_BUILD:
            return PropertyType.NEW_BUILD;
        default:
            return null;
    }
}

export class PropertyBuilder {
    private propertyType: PropertyType;
    private energyLabel?: EnergyLabel;
    private purchasePrice?: Money;
    private sustainabilityLoan?: boolean;
    private sustainability?: Money;
    private renovation?: boolean;
    private renovationAmount?: Money;

    withPropertyType(propertyType: PropertyType): this {
        this.propertyType = propertyType;
        return this;
    }

    withEnergyLabel(energyLabel: EnergyLabel): this {
        this.energyLabel = energyLabel;
        return this;
    }

    withPurchasePrice(purchasePrice: Money): this {
        this.purchasePrice = purchasePrice;
        return this;
    }

    withSustainabilityLoan(sustainabilityLoan: boolean): this {
        this.sustainabilityLoan = sustainabilityLoan;
        return this;
    }

    withSustainability(sustainability: Money): this {
        this.sustainability = sustainability;
        return this;
    }

    withRenovation(renovation: boolean) {
        this.renovation = renovation;
        return this;
    }

    withRenovationAmount(amount: Money) {
        this.renovationAmount = amount;
        return this;
    }

    build(): Property {
        return {
            property_type: this.propertyType,
            energy_label: this.energyLabel,
            purchase_price: this.purchasePrice,
            sustainability_loan: this.sustainabilityLoan,
            sustainability_amount: this.sustainability,
            renovation: this.renovation,
            renovation_amount: this.renovationAmount
        } as Property;
    }
}
